<template>
    <Main>
        <div slot="main" class="main slaughter">
            <div class="bank_title">
                <Header :data='headerInfo'></Header>
                <div v-if="goBackShow" class="gobcak" @click="goBack"><img src="../../assets/return.png"
                        alt=""><span>返回</span></div>
            </div>
            <div class="content">
                <div class="left">
                    <div class="l_t">
                        <div class="server">
                            <div>
                                <span class="card_">综合概览</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                        </div>
                        <div class="info">
                            <span>{{ info.row[0] }}</span>
                            <div class="info_bg">
                                <span>{{ info.row[1] }}</span>
                                <span>信用值</span>
                            </div>
                        </div>
                        <div class="box">
                            <div class="people">
                                <div class="p_item" v-show="headDate == '/nmzlqlogin'" style="margin-top:0">
                                    <img src="../../assets/icon_7.png" alt="">
                                    <div class="people_">
                                        <span>{{ generalOverview.eDuSettleAmount }}</span>
                                        <span>使用额度结算金额(万)</span>
                                    </div>
                                </div>
                                <div v-show="headDate != '/nmzlqlogin'" class="p_item" style="margin-top:0">
                                    <img src="../../assets/icon_2.png" alt="">
                                    <div class="people_">
                                        <span>{{ generalOverview.sheepBuy }}</span>
                                        <span>累计屠宰收购羊只(只)</span>
                                    </div>
                                </div>
                                <div class="p_item">
                                    <img src="../../assets/icon_3.png" alt="">
                                    <div class="people_">
                                        <!-- <span>{{ generalOverview.settleTotalAmount }}</span> -->
                                        <span>{{ cowTotal }}</span>
                                        <span>累计结算金额(万)</span>
                                    </div>
                                </div>
                                <div class="p_item">
                                    <img src="../../assets/icon_4.png" alt="">
                                    <div class="people_">
                                        <span>{{ generalOverview.financingAmount }}</span>
                                        <span>融资总金额(万)</span>
                                    </div>
                                </div>
                            </div>
                            <div class="people" style="margin-left:0.84rem">
                                <div class="p_item" style="margin-top:0">
                                    <img src="../../assets/icon_5.png" alt="">
                                    <div class="people_">
                                        <!-- <span>{{ generalOverview.cowBuy }}</span> -->
                                        <span>{{ moneyTotal }}</span>
                                        <span>累计屠宰收购牛只(头)</span>
                                    </div>
                                </div>
                                <div class="p_item">
                                    <img src="../../assets/icon_6.png" alt="">
                                    <div class="people_">
                                        <span>{{ generalOverview.chargeOrderSize }}</span>
                                        <span>监管笔数(笔)</span>
                                    </div>
                                </div>
                                <div class="p_item" v-show="headDate != '/nmzlqlogin'">
                                    <img src="../../assets/icon_7.png" alt="">
                                    <div class="people_">
                                        <span>{{ generalOverview.eDuSettleAmount }}</span>
                                        <span>使用额度结算金额(万)</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="l_b">
                        <div class="server">
                            <div>
                                <span class="card_">实时屠宰入场动态</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                        </div>
                        <div class="l_top">
                            <div class="top" v-show="headDate != '/nmzlqlogin'">
                                <span>{{ slaughterEntryDyn.sheepEntryQuan || 0 }}</span>
                                <span>今日入场羊只(只)</span>
                            </div>
                            <div class="top" :style="{ marginLeft: headDate != '/nmzlqlogin' ? '1.8' : '0' }">
                                <span>{{ slaughterEntryDyn.cowEntryQuan || 0 }}</span>
                                <span>今日入场牛只(头)</span>
                            </div>
                            <div class="top">
                                <span>{{ slaughterEntryDyn.todaySettleAmount || 0 }}</span>
                                <span>今日结算金额(万)</span>
                            </div>
                        </div>
                        <dv-scroll-board :config="config"
                            style="width:8.38rem;height:3.9rem;margin-top: .5rem;margin-left: .25rem;" />
                    </div>
                </div>
                <div class="right">
                    <div class="r_t">
                        <div class="server">
                            <div>
                                <span class="card_">屠宰结算金额分布</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                            <div class="rets">
                                <div class="ret" v-if="retShow_1" @click="goRetBack_1">返回上一层</div>
                                <el-select class="select" v-model="time" placeholder="2022" @change="changeBarYearData"
                                    style="margin-right: 0.25rem;font-size:0.13rem">
                                    <el-option v-for="item in times" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="l_top">
                            <div class="top">
                                <span>{{ slaughterAmountDis.totalSettleAmount || 0 }}</span>
                                <span>累计结算金额(万)</span>
                            </div>
                            <div class="top">
                                <span>{{ slaughterAmountDis.settlementAmount || 0 }}</span>
                                <span>使用额度结算金额(万)</span>
                            </div>
                        </div>
                        <div id="barChart" v-if="isShow_1"></div>
                    </div>
                    <div class="r_b">
                        <div class="server">
                            <div>
                                <span class="card_">屠宰收购数量分布</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                            <div class="rets">
                                <div class="ret" v-if="retShow" @click="goRetBack">返回上一层</div>
                                <el-select class="select" v-model="time_1" placeholder="2022" @change="changeLineYearData"
                                    style="margin-right: 0.25rem;font-size:0.13rem">
                                    <el-option v-for="item in times_1" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="l_top">
                            <div class="top" v-show="headDate != '/nmzlqlogin'">
                                <span>{{ slaughterBuyQuanDis.sheepBuyQuan }}</span>
                                <span>累计屠宰收购羊只(只)</span>
                            </div>
                            <div class="top" :style="{ marginLeft: headDate != '/nmzlqlogin' ? '1.8' : '0' }">
                                <span>{{ slaughterBuyQuanDis.cowBuyQuan }}</span>
                                <span>累计屠宰收购牛只(头)</span>
                            </div>
                        </div>
                        <div id="lineChart" v-if="isShow"></div>
                    </div>
                </div>
                <video src="../../assets/66.mp4" muted autoplay="autoplay" loop="loop"></video>
            </div>
        </div>
    </Main>
</template>
  
<script>
import Main from "@/components/main.vue";
import Header from "../../components/headerXn.vue";
export default {
    components: {
        Main,
        Header,
        // XChart
    },
    data() {
        return {
            info: {},//综合概览信息
            headerInfo: {},
            userInfo: {},
            chart: null,//柱状
            myChart: null,//折线
            retShow: false,//折线显示
            retShow_1: false,
            isShow: true,//折线下钻dom显示隐藏
            isShow_1: true,//柱状图下钻dom显示隐藏
            goBackShow: true,
            time: '2022',
            times: [
                { value: '0', label: '2022' },
                { value: '1', label: '2023' },
            ],
            time_1: '2022',
            times_1: [
                { value: '0', label: '2022' },
                { value: '1', label: '2023' },

            ],
            config: {},
            generalOverview: {},//综合概览数据
            slaughterEntryDyn: {}, // 实时入场动态
            slaughterAmountDis: {}, // 屠宰金额分布
            slaughterBuyQuanDis: {},// 屠宰收购数量分布
            breederList: [],
            linedata: [],
            linedata_1: [],
            growdata: [],
            growdata_1: [],
            saveScreenDataL: {},//保存全部信息
            barNum: '',
            lineNum: '',
            cowTotal:0,//累计屠宰收购牛只
            moneyTotal:0,//累计结算金额
            headDate: '',//判断是否为正蓝旗登录

        };
    },
    watch: {},
    created() {
        this.headDate = window.localStorage.getItem('LOGIN')
        this.info = JSON.parse(window.localStorage.getItem('SLAUGHTERINFO'))
        this.cowTotal=this.info.row[3]
        this.moneyTotal=this.info.row[2].split('头')[0]
        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))
        this.headerInfo = {
            name: window.localStorage.getItem('screenName')
        }
        this.getData()
    },
    mounted() {
        // this.setLineData(this.linedata, 'lineChart')
    },
    methods: {
        changeBarYearData() {
            if (this.time == '0') {
                this.slaughterAmountDis = this.saveScreenData.slaughterAmountDis
            }
            if (this.time == '1') {
                this.slaughterAmountDis = this.saveScreenData['slaughterAmountDis-2023']
            }
            this.barChange(this.barNum)
        },
        changeLineYearData() {
            if (this.time_1 == '0') {
                this.slaughterBuyQuanDis = this.saveScreenData.slaughterBuyQuanDis

            }
            if (this.time_1 == '1') {
                this.slaughterBuyQuanDis = this.saveScreenData['slaughterBuyQuanDis-2023']
            }
            this.lineChange(this.lineNum)
        },
        getData() {
            this.$http({
                url: 'screenapp-service/screenSlaughterProcess/page/child/data',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "parentId": "28",
                    "menuMark": "13",
                    deptId: this.userInfo.dept.deptId,
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    const screenData = JSON.parse(data.result.screenData)
                    this.saveScreenData = screenData
                    console.log(this.saveScreenData, '1111111111111111111');
                    this.generalOverview = screenData.generalOverview
                    this.slaughterEntryDyn = screenData.slaughterEntryDyn
                    this.slaughterAmountDis = screenData.slaughterAmountDis
                    this.slaughterBuyQuanDis = screenData.slaughterBuyQuanDis
                    this.breederList = []
                    this.slaughterEntryDyn.tableData.list.forEach((item) => {
                        this.breederList.push([item.entryTime, item.farmerName, item.entryQuan, item.settleAmount])
                    })
                    this.config = {
                        header: ['入场时间', '养殖户名称', '入场数量', '结算金额(万)'],
                        data: this.breederList,
                        align: ['left', 'left', 'left', 'right'],
                        // columnWidth: [260, 200, 180, 220],
                        headerHeight: 35,
                        rowNum: 5,
                        waitTime: 2000
                    }
                    this.barChange()
                    this.lineChange()
                } else {
                    // this.$message.error(data);
                }
            })
        },
        barChange(val) {
            if (!this.retShow_1) {
                this.growdata = [
                    { title: "累计结算金额", label: this.slaughterAmountDis.months, value: this.slaughterAmountDis.leiJiJieSuanAmount.monthValue },
                    { title: "额度结算金额", label: this.slaughterAmountDis.months, value: this.slaughterAmountDis.eDuJieSuanJinE.monthValue },
                ]
            } else {
                this.growdata = [
                    { title: "累计结算金额", label: this.slaughterAmountDis.days, value: this.slaughterAmountDis.leiJiJieSuanAmount[val] },
                    { title: "额度结算金额", label: this.slaughterAmountDis.days, value: this.slaughterAmountDis.eDuJieSuanJinE[val] },
                ]
            }
            this.$nextTick(() => {
                this.growthChart(this.growdata, 'barChart')
            })
        },
        lineChange(val) {
            if (!this.retShow) {
                if (this.headDate != '/nmzlqlogin') {
                    this.linedata = [
                        { title: "羊", label: this.slaughterBuyQuanDis.months, value: this.slaughterBuyQuanDis.sheep.monthValue },
                        { title: "牛", label: this.slaughterBuyQuanDis.months, value: this.slaughterBuyQuanDis.cow.monthValue },
                    ]
                } else {
                    this.linedata = [
                        { title: "牛", label: this.slaughterBuyQuanDis.months, value: this.slaughterBuyQuanDis.cow.monthValue },
                    ]
                }

            } else {
                if(this.headDate != '/nmzlqlogin'){
                    this.linedata = [
                    { title: "羊", label: this.slaughterBuyQuanDis.days, value: this.slaughterBuyQuanDis.sheep[val] },
                    { title: "牛", label: this.slaughterBuyQuanDis.days, value: this.slaughterBuyQuanDis.cow[val] },
                ]
                } else {
                    this.linedata = [
                    { title: "牛", label: this.slaughterBuyQuanDis.days, value: this.slaughterBuyQuanDis.cow[val] },
                ]
                }
             
            }
            this.$nextTick(() => {
                this.setLineData(this.linedata, 'lineChart')
            })
        },
        // 折线下钻隐藏
        goRetBack() {
            this.retShow = false
            this.lineChange()
        },
        // 柱状图下钻隐藏
        goRetBack_1() {
            this.retShow_1 = false
            this.barChange()
        },
        // 返回上一层
        goBack() {
            this.goBackShow = false
            this.$router.push({ name: 'slaughter' })
        },
        // 设置折线图
        setLineData(data, dom) {
            const colors = ['#1EE7E7', '#2C76FE', '#5931FC'];
            const legend = [];
            const series = [];
            let xAxis = [];
            data.forEach((item, index) => {
                legend.push({
                    name: item.title,
                    textStyle: { color: '#00E0DB' },
                    icon: 'circle',
                    itemWidth: 4,
                    itemhight: 4,
                })
                xAxis = item.label
                series.push({
                    name: item.title,
                    type: "line",
                    lineStyle: {
                        width: 2,
                    },
                    color: colors[index],
                    data: item.value,
                })
            })
            const line = {
                dom,
                xAxis,
                legend: {
                    data: legend,
                    // x: 'right',
                    // y: 'top',
                    top: "3%",
                    right: "2%",
                    itemWidth: 8,
                    itemHeight: 8,
                    padding: [10, 0, 0, 0],
                },
                series: series
            }
            this.lineChart(line)
        },
        lineChart(data) {
            this.myChart = this.$echarts.init(document.getElementById(data.dom))
            // 隐藏动画加载效果。
            var option = {
                color: ['#106BDC', '#2C76FE', '#5931FC'],
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        console.log(params, 'params');
                        if (params.length == 1) {
                            return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].name
                                }</p><br/>
                         <p>
                        <p style="font-size: 14px; font-weight: normal;">${params[0].seriesName == '羊' ? `羊只收购数量${params[0].value > 9999 ? '(万只)：' : '(只)：' + params[0].value
                                    }` : `牛只收购数量${params[0].value > 9999 ? '(万头)：' : '(头)：' + params[0].value
                                    }`} </p><br/>
                         `;
                        } else if (params.length == 2) {
                            return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].name
                                }</p><br/>
                         <p>
                        <p style="font-size: 14px; font-weight: normal;">羊只收购数量${params[0].value > 9999 ? '(万只)：' : '(只)：' + params[0].value
                                }</p><br/>
                        <p style="font-size: 14px; font-weight: normal;">牛只收购数量${params[1].value > 9999 ? '(万头)：' : '(头)：' + params[1].value
                                }</p>
                         `;
                        } else {
                            return
                        }

                    },
                    padding: [5, 20],
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: data.legend,
                grid: {
                    top: '25%',
                    left: '6%',
                    right: '2%',
                    bottom: '10%',
                    // containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true
                    },
                    data: data.xAxis,
                },
                yAxis: {
                    name: '收购数量',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 55, 0, 0],
                        lineHeight: 45,
                        // align:'left'
                    },
                    // nameLocation:'end',
                    type: 'value',
                    splitNumber: 4,
                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                },
                series: data.series,
            }
            this.myChart.clear();
            this.myChart.setOption(option)
            window.addEventListener('resize', () => {
                this.myChart.resize()
            })
            this.myChart.on('click', (params) => {
                // console.log(params, 'params');
                if (this.retShow) return
                if (this.myChart != null && this.myChart != "" && this.myChart != undefined) {
                    this.isShow = false
                }
                this.$nextTick(() => {
                    this.isShow = true
                    this.$nextTick(() => {
                        this.retShow = true
                        // this.linedata = [
                        //     { title: "羊", label: this.slaughterBuyQuanDis.days, value: this.slaughterBuyQuanDis.sheep[params.dataIndex + 1] },
                        //     { title: "牛", label: this.slaughterBuyQuanDis.days, value: this.slaughterBuyQuanDis.cow[params.dataIndex + 1] },
                        // ]
                        this.lineNum = params.dataIndex + 1
                        this.lineChange(this.lineNum)
                    })
                })
            });
        },
        //柱状图
        growthChart(data, dom) {
            // var a=document.ge
            // console.log(data);
            this.chart = this.$echarts.init(document.getElementById(dom));
            var option = {
                legend: {
                    top: "3%",
                    right: "2%",
                    itemWidth: 8,
                    itemHeight: 8,
                    padding: [10, 0, 0, 0],
                    data: [
                        {
                            name: data[0].title,
                            textStyle: {
                                color: '#0EDAE2'
                            },
                        },
                        {
                            name: data[1].title,
                            textStyle: {
                                color: '#00ACFC'
                            },
                            // bottom: 10
                        }
                    ]
                },
                grid: {
                    top: '25%',
                    left: '6%',
                    right: '2%',
                    bottom: '10%',
                    // containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    scale: false,
                    axisTick: {
                        // X轴线 刻度线
                        // show: true,
                        // inside: true,
                        // alignWithLabel: true
                        show: false,
                    },
                    data: data[0].label
                },
                yAxis:
                {
                    name: '结算金额 (万)',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 40, 0, 0],
                        lineHeight: 45,
                        // align:'left'
                    },
                    // nameLocation:'end',
                    type: 'value',
                    splitNumber: 4,
                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                },

                series: [
                    {
                        name: data[0].title,
                        data: data[0].value,
                        type: 'bar',
                        symbol: 'circle',
                        barWidth: 10,
                        itemStyle: {
                            opacity: 1,
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 1,
                                    color: '#0BE5E1',
                                },
                                {
                                    offset: 0,
                                    color: '#06FDF5',
                                },
                            ]),
                        },
                    },
                    {
                        name: data[1].title,
                        data: data[1].value,
                        type: 'bar',
                        symbol: 'circle',
                        barWidth: 10,
                        itemStyle: {
                            opacity: 1,
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 1,
                                    color: '#2C9FFE',
                                },
                                {
                                    offset: 0,
                                    color: '#00ACFC',
                                },
                            ]),
                        },
                        // backgroundStyle: {
                        //     color: 'rgba(44, 118, 254, 0.2)'
                        // },
                    },
                ],
                tooltip: {//鼠标悬浮提示数据
                    trigger: 'axis',
                    axisPointer: {
                        type: 'line'
                    },
                    formatter: function (params) {
                        // console.log(params, 2)
                        if (params.length == 1) {
                            return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].axisValue
                                }</p><br/>
                        <p>
                          <span style="font-size: 14px; font-weight: normal;">${params[0].seriesName == '累计结算金额' ? `累计结算金额(万)： ${params[0].value || 0}` : `额度结算金额(万)： ${params[0].value || 0}`}  </span>
                        </p>`;
                            // return params.name
                        } else if (params.length == 2) {
                            return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].axisValue
                                }</p><br/>
                        <p>
                          <span style="font-size: 14px; font-weight: normal;">累计结算金额(万)： ${params[0].value || 0} </span>
                        </p><br/> 
                         <p>
                          <span style="font-size: 14px; font-weight: normal;">额度结算金额(万)： ${params[1].value || 0} </span>
                         </p>`;
                            // return params.name
                        } else {
                            return
                        }
                    },
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    // borderWidth: 2,
                    // textStyle: {
                    //     color: '#fff',
                    // },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                }
            };
            this.chart.clear()
            this.chart.setOption(option)
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
            this.chart.on('click', (params) => {
                // console.log(params, 'params');
                if (this.retShow_1) return
                if (this.chart != null && this.chart != "" && this.chart != undefined) {
                    this.isShow_1 = false
                }
                this.$nextTick(() => {
                    this.isShow_1 = true
                    this.$nextTick(() => {
                        this.retShow_1 = true
                        // this.growdata = [
                        //     { title: "累计结算金额", label: this.slaughterAmountDis.days, value: this.slaughterAmountDis.leiJiJieSuanAmount[params.dataIndex + 1] },
                        //     { title: "额度结算金额", label: this.slaughterAmountDis.days, value: this.slaughterAmountDis.eDuJieSuanJinE[params.dataIndex + 1] },
                        // ]
                        this.barNum = params.dataIndex + 1
                        this.barChange(this.barNum)
                    })
                })
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 100%;

    .bank_title {
        position: relative;

        .gobcak {
            width: .875rem;
            height: .4375rem;
            position: absolute;
            z-index: 99;
            bottom: -0.22rem;
            left: 0.25rem;
            font-size: .2rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #00E0DB;
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
                width: .3rem;
                height: .3rem;
            }

            span {
                margin-left: .05rem;
            }
        }
    }


    .content {
        position: relative;
        padding: .25rem;
        box-sizing: border-box;
        // background: url('../../assets/bg-hhr.png');
        // background-size: 100% 100%;
        display: flex;
        min-height: 12.5rem;
        // min-height: calc(100vh - 1rem);


        video {
            position: absolute;
            top: 0;
            left: 0;
            z-index: -5;
            width: 100%;
            height: 100%;
        }

        .left {
            width: 8.88rem;

            .l_t {
                height: 5.88rem;
                background: linear-gradient(74deg, rgba(0, 223, 218, 0.05) 8%, rgba(0, 223, 218, 0.01) 70%);
                border-left: 0.01rem solid rgba(0, 224, 219, 0.3);

                .info {
                    height: 1rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-left: .25rem;
                    margin-top: .25rem;

                    span {
                        font-size: 0.33rem;
                        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                        font-weight: bold;
                        color: #00E0DB;
                        min-width: 50%;
                    }

                    .info_bg {
                        width: 2.1rem;
                        height: 0.49rem;
                        margin-right: .4rem;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        background: url('../../assets/icon_1.png');
                        background-size: 100% 100%;

                        span {
                            font-size: 0.6rem;
                            font-family: Agency FB-Bold, Agency FB;
                            font-weight: bold;
                            color: #FFE11D;
                            margin-top: -0.2rem;
                            margin-left: 0.3rem;
                        }

                        span:nth-child(2) {
                            font-size: 0.23rem;
                            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                            font-weight: 400;
                            color: #FFFFFF;
                            margin-top: .5rem;
                        }
                    }
                }
            }

            .l_b {
                margin-top: .25rem;
                height: 5.88rem;
                background: linear-gradient(74deg, rgba(0, 223, 218, 0.05) 8%, rgba(0, 223, 218, 0.01) 70%);
                border-left: 0.01rem solid rgba(0, 224, 219, 0.3);
            }
        }

        .right {
            width: 14.38rem;
            margin-left: .25rem;

            .server {
                background: linear-gradient(119deg, rgba(0, 222, 217, 0.3) 19%, rgba(0, 223, 218, 0) 40%);

            }

            .r_t {
                height: 5.88rem;
                background: linear-gradient(-90deg, rgba(0, 222, 217, 0.05) 0%, rgba(0, 223, 218, 0.01) 38%);
                border-right: 0.01rem solid rgba(0, 224, 219, 0.3);

                #barChart {
                    width: 100%;
                    height: 4.2rem;
                    margin-top: .3rem;
                }
            }

            .r_b {
                margin-top: .25rem;
                height: 5.88rem;
                background: linear-gradient(-90deg, rgba(0, 223, 218, 0.05) 8%, rgba(0, 223, 218, 0.01) 47%);
                border-right: 0.01rem solid rgba(0, 224, 219, 0.3);

                #lineChart {
                    width: 100%;
                    height: 4.2rem;
                    margin-top: .3rem;
                }
            }
        }

    }

    .server {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.48rem;
        background: linear-gradient(119deg, rgba(0, 222, 217, 0.3) 19%, rgba(0, 223, 218, 0) 50%);

        // padding-top: .24rem;
        .card_ {
            font-size: 0.23rem;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #00E0DB;
            padding-left: .25rem;
        }

        .date {
            // margin-left: 1.2rem;
            color: #7B8A89;
            padding-right: 0.15rem;

            span {
                padding: .03rem .05rem;
                border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                font-size: 0.13rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                background: rgba(255, 255, 255, 0.05);
                opacity: .5;
                font-weight: 400;
                cursor: pointer;
            }

            span:nth-child(2) {
                margin: 0 .13rem;
            }
        }
    }



    .box {
        display: flex;
    }

    .people {
        margin-top: .09rem;
        margin-left: .35rem;
        display: flex;
        flex-direction: column;

        .p_item {
            display: flex;
            align-items: center;
            margin-top: .66rem;

            img {
                width: 0.7rem;
                height: 0.6rem;
                box-sizing: border-box;
                object-fit: cover;
            }

            .people_ {
                margin-left: .19rem;
                display: flex;
                flex-direction: column;
                font-size: 0.38rem;
                font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
                font-weight: bold;
                color: #FFE11D;

                span:nth-child(2) {
                    font-size: 0.18rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                    margin-top: .2rem;
                }
            }
        }

    }

    .l_top {
        display: flex;
        margin-left: .46rem;
        margin-top: .41rem;

        .top {
            display: flex;
            flex-direction: column;
            margin-left: 1.8rem;

            span {
                font-size: 0.38rem;
                font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                font-weight: bold;
                color: #00E0DB;
            }

            span:nth-child(2) {
                font-size: 0.15rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #FFFFFF;
                margin-top: .2rem;
            }
        }

        .top:nth-child(1) {
            margin-left: 0;
        }
    }

    .rets {
        display: flex;
        margin-bottom: -0.1rem;

        .ret {
            min-width: 0.88rem;
            height: 0.38rem;
            background: #013D4E;
            border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
            opacity: 1;
            line-height: .38rem;
            text-align: center;
            margin-right: 0.2rem;
            font-size: 0.13rem;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #00E0DB;
            cursor: pointer;
        }
    }

}
</style>
<style lang="scss">
.slaughter {
    .slaughter .dv-digital-flop canvas {
        text-align: left !important;
        width: 80% !important;
        height: 80% !important;
    }

    // .dv-digital-flop canvas {
    //     width: 80% !important;
    //     height: 80% !important;
    //     margin-left: .2rem !important;
    // }

    .active-ring-name {
        font-size: .23rem !important;
        padding-top: .1rem;
    }

    .el-input__inner {
        // width: 2.79rem;
        height: 0.38rem;
        background: rgba(0, 224, 219, 0.08) !important;
        border: none;
        border-radius: 0.03rem;
        color: #FFFFFF !important;
        font-size: .13rem !important;
    }

    .el-input__icon {
        color: #00E0DB;
    }

    //下拉
    .el-select {
        width: 1.13rem;
        height: 0.38rem;
        line-height: .38rem;
        background: rgba(0, 223, 218, 0.0588);
        border-radius: 0rem 0rem 0rem 0rem;
        opacity: 1;
        border: 0.01rem solid rgba(0, 223, 218, 0.4);

        .el-input__inner {
            // width: 2.79rem;
            height: 0.38rem;
            line-height: .38rem;
            color: #00E0DB !important;
            font-size: .13rem !important;
            padding-left: .1rem;
        }
    }

    .el-select .el-input .el-select__caret {
        color: #00E0DB !important;
        line-height: inherit;

    }

    .search_input>.el-input__inner {
        padding: 0 0 0 .4rem;
        //     background: url('../../assets/search\ \(1\).png') no-repeat;
        //    background-position: .1rem,.1rem;
    }


    .header {
        background: rgba(0, 224, 219, 0.08) !important;

    }

    // DataV
    .header-item {
        font-size: .175rem !important;
        opacity: .85;
        color: #00E0DB;
    }

    .rows {
        padding: .1rem 0 .2rem 0;
    }

    .row-item {
        background: transparent !important;

        div:nth-child(7) {
            span {
                margin-left: .6rem !important;
            }
        }
    }

    .row-item:hover {
        background-color: rgba(255, 255, 255, 0.05) !important;
    }

    .ceil {
        font-size: .15rem !important;

    }

    // .ceil:first-child {
    //     color: #FFC300;
    // }
    ::v-deep .dv-digital-flop {
        font-size: 0.43rem !important;
        font-family: Source Han Sans CN-Bold, Source Han Sans CN !important;
        font-weight: bold !important;
        color: #FFE11D !important;
        margin-top: .05rem !important;
    }
}
</style>